<template>
  <CHeader with-subheader>
    <CToggler
      in-header
      class="ml-3 d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      @click="$store.commit('toggleSidebarDesktop')"
    />
    <CHeaderBrand class="mx-auto d-lg-none" to="/">
    </CHeaderBrand>
    <CHeaderNav class="d-md-down-none mr-auto">
    <!-- add custom header content here -->
      <CBreadcrumbRouter class="border-0 mb-0"/>
    </CHeaderNav>
    <CHeaderNav>
      <CHeaderNavItem class="px-3">
        <button
          @click="() => $store.commit('toggle', 'darkMode')"
          class="c-header-nav-btn"
        >
          <CIcon v-if="$store.state.darkMode" name="cil-sun"/>
          <CIcon v-else name="cil-moon"/>
        </button>
      </CHeaderNavItem>
      <TheHeaderDropdownNotif/>
      <TheHeaderDropdownTasks/>
      <CHeaderNavLink>
        {{ username }}
      </CHeaderNavLink>
      <TheHeaderDropdownAccnt/>
    </CHeaderNav>

    <!--  move display to header first row
    <CSubheader class="px-3">-->
    <!--      <CBreadcrumbRouter class="border-0 mb-0"/>-->
    <!--    </CSubheader>-->
  </CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'
import TheHeaderDropdownNotif from './TheHeaderDropdownNotif'
import TheHeaderDropdownTasks from './TheHeaderDropdownTasks'

export default {
  name: 'TheHeader',
  computed:{

  },
  data() {
    return {
      username: localStorage.getItem('username'),
    }
  },
  components: {
    TheHeaderDropdownAccnt,
    TheHeaderDropdownNotif,
    TheHeaderDropdownTasks
  }
}
</script>
